module.exports = {
    SecertKey: '8e89a619-025b-4c79-9a7c-b21030b3b7b8',
    RoutUser: '/user/home',
}


// WEBPACK FOOTER //
// ./src/config/index.js